import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

export default function BackdropLoader() {
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, flexDirection: 'column' })}
            open
        >
            <CircularProgress color="inherit" />
            
        </Backdrop>
    );
}
